<template>
  <TextBase is="td" :font="font" size="text-sm" :color="color" :class="classes">
    <slot />
  </TextBase>
</template>

<script setup>
import { computed } from 'vue'
import TextBase from '@/Common/Text/TextBase.vue'
import { getPaddingClasses } from './common'

const props = defineProps({
  padding: {
    type: String,
    default: 'lg',
  },
  bold: Boolean,
  right: Boolean,
  center: Boolean,
  wrap: Boolean,
})

const color = computed(() => (props.bold ? 'text-gray-900' : 'text-gray-500'))

const font = computed(() => (props.bold ? 'font-medium' : 'font-normal'))

const classes = computed(() =>
  [right.value, wrap.value, paddingClasses.value].join(' ')
)

const paddingClasses = computed(() => getPaddingClasses(props.padding))

const right = computed(() => {
  if (props.right) return 'text-right'
  else if (props.center) return 'text-center'
  else return ''
})

const wrap = computed(() => (props.wrap ? '' : 'whitespace-nowrap'))
</script>
